export default "__VITE_ASSET__CSKzkBlc__"